import {ReactSVG} from "react-svg";

export const LogoutIcon = () => {
    return (
        <ReactSVG src={"/fri-media/logout-icon.svg"}></ReactSVG>
    );
};